// extracted by mini-css-extract-plugin
module.exports = {"container":"ContentBlockTextBgColor_container__bCAy3","Stroke":"ContentBlockTextBgColor_Stroke__R8Uqe"};